import {canManagePlatform,canManageRoles,type User} from '@reados/contracts';
export const canUseAdmin=(user:Pick<User,'role'>)=>canManagePlatform(user.role);
export const canManageAdmins=(user:Pick<User,'role'>)=>canManageRoles(user.role);
export const roleLabel=(role:User['role'])=>role==='super_admin'?'超级管理员':role==='admin'?'管理员':'普通用户';
